/* eslint-disable @tooling/perkbox/i18n */
import {SavingBlock} from "@irati-web/perks/src/components/Saving/SavingBlock"
import {Deal, WellnessCarousel} from "@irati/types"
import {ButtonRouterLink, RouterLink} from "@irati/ui/src/Link"
import {H1} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"
import mainTheme from "@irati/ui/src/global/theme"
import {Container,
  Content,
  Description,
  PromoSection,
  StyledPill,
  Thumbnail,
  BackgroundImg,
  HeroSliderSettings as SliderSettings
} from "./styled"

export const HeroSliderSettings = SliderSettings

interface WD extends WellnessCarousel, Deal {
  __typename: any
}
type Props = Partial<WD> & {
  link: string,
  onClick?: () => void
}

export const Hero = ({
  title,
  link,
  ctaText,
  subtext,
  brandName,
  textColor,
  description,
  bannerImage,
  thumbnailImage,
  backgroundImage = bannerImage,
  onClick = () => {},
  ...props
}: Props) => (
  <RouterLink to={link} onClick={onClick}>
    <Container>
      <BackgroundImg imgUrl={backgroundImage!} />
      {props.savings?.boostedSavings ?
        <StyledPill
          text={<FormattedMessage id="perks.deals.boostedSaving.boostedAmount.text" />}
          iconType="instant"
          backgroundColor={mainTheme.colors.utility.acid} />
        :
        null}
      {thumbnailImage ? <Thumbnail src={thumbnailImage} alt={brandName ?? "brand logo"} /> : null}
      <Content color={textColor}>
        {props.savings ? (
          <PromoSection>
            <SavingBlock deal={{...props, earnPoints: false}} />
          </PromoSection>
        ) : null}

        {title ? <H1 marginBottom={1}>{title}</H1> : null}
        <Description hasThumbnail={!thumbnailImage} marginTop={title ? 0 : 1}>
          {description || subtext}
        </Description>
        <ButtonRouterLink
          primary
          to={link}
          marginTop={2}
          onClick={(e) => {
            e.stopPropagation()
            onClick()
          }}>
          {ctaText || <FormattedMessage id="platform.banner.link.text" />}
        </ButtonRouterLink>
      </Content>
    </Container>
  </RouterLink>
)
